(function () {
    angular.module('EventListApp').directive('validateImage', ['$q', function ($q) {
        return {
            link: function postLink(scope, element, attrs) {
                var defImageSrc = attrs.errorSrc || 'https://images.eventact.com/eventact/participant.png';
                attrs.$observe('ngSrc', function (ngSrc) {
                    var deferred = $q.defer();
                    var image = new Image();
                    image.onerror = function () {
                        deferred.resolve(false);
                        if (attrs.hideError != undefined)
                            element.hide(); // hide if needed
                        else
                            element.attr('src', defImageSrc); // set default image
                    };
                    image.onload = function () {
                        deferred.resolve(true);
                    };
                    image.src = ngSrc;
                    return deferred.promise;
                });
            }
        }
    }])
})();